import { render } from "./NewestNews.vue?vue&type=template&id=faa6befc&scoped=true"
const script = {}

import "./NewestNews.vue?vue&type=style&index=0&id=faa6befc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa6befc"]])

export default __exports__